import Select from "react-select";
import { useSelector } from "react-redux";

interface Props {
  handleChange: (x: any) => void;
  DropdownIndicator: any;
  genders: any;
  setfodlerSelected: any;
}

export const AddArticleBottomDrawer = ({
  handleChange,
  DropdownIndicator,
  genders,
  setfodlerSelected,
}: Props) => {
  const { user } = useSelector((state: any) => state.auth);
  const customStylesCreateModern = {
    control: (base: any, state: any) => ({
      ...base,
      background: "white",
      borderColor: state.isFocused ? "#00468c" : "#e2e8f0",
      borderRadius: "8px",
      padding: "2px",
      fontSize: "14px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#00468c",
      },
    }),
    placeholder: (base: any) => ({
      ...base,
      color: "#94a3b8",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
      zIndex: 100
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#00468c" : state.isFocused ? "#f1f5f9" : "white",
      color: state.isSelected ? "white" : "#1e293b",
      padding: "10px 12px",
      fontSize: "14px",
      cursor: "pointer"
    }),
  };

  return (
    <div className="create_collection_form_modern" style={{ 
      padding: "24px", 
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      maxWidth: "800px",
      margin: "0 auto",
      width: "100%"
    }}>
      <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#1e293b", margin: 0 }}>New Article</h3>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px" }}>
        {/* Left Column */}
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Article Name</label>
            <input
              type="text"
              name="name"
              id="ArticleName"
              placeholder="e.g. Vintage Jeans"
              onChange={handleChange}
              style={{ 
                border: "1px solid #e2e8f0", 
                borderRadius: "8px", 
                width: "100%", 
                outline: "none", 
                fontSize: "14px", 
                padding: "10px 14px",
                background: "white",
                transition: "border-color 0.2s"
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Gender</label>
            <Select
              options={genders}
              styles={customStylesCreateModern}
              onChange={setfodlerSelected}
              placeholder="Select gender..."
              components={{ DropdownIndicator }}
            />
          </div>
        </div>

        {/* Right Column */}
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Company's Name</label>
            <input
              type="text"
              name="company"
              id="companyName"
              value={user && user.company.name}
              disabled
              style={{ 
                border: "1px solid #e2e8f0", 
                borderRadius: "8px", 
                width: "100%", 
                outline: "none", 
                fontSize: "14px", 
                padding: "10px 14px",
                background: "#f8fafc",
                color: "#64748b",
                cursor: "not-allowed"
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Season</label>
            <input
              type="text"
              name="season"
              id="Season"
              placeholder="e.g. Summer 2027"
              onChange={handleChange}
              style={{ 
                border: "1px solid #e2e8f0", 
                borderRadius: "8px", 
                width: "100%", 
                outline: "none", 
                fontSize: "14px", 
                padding: "10px 14px",
                background: "white"
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
